import React from 'react';
import { DK_THEME, THEME } from '../configs/main';
import DKGlobalInject from './dk/global-inject';
import { injectGlobal } from 'styled-components';
import * as utils from './utils';

let GlobalInject = (props) => {
    injectGlobal`
        body {
            left: 0;
            top: 0;
            right: 0;
        }
        ${utils.fullWidth()}
        ${utils.fullHeight()}
        ${utils.uppercase()}
        ${utils.lowercase()}
        ${utils.capitalize()}
        ${utils.flex()}
        ${utils.textCenter()}
        ${utils.textLeft()}
        ${utils.textRight()}
        ${utils.resetLink()}
        ${utils.blockCenter()}
        ${utils.verticalSpaceBetween()}
        ${utils.withoutScroll()}
        ${utils.shortText()}
        ${utils.textBold()}
        ${utils.pointer()}
        ${utils.fadeIn()}
        ${utils.fadeOut()}
    `;

    return THEME === DK_THEME ? (
        <DKGlobalInject>{props.children}</DKGlobalInject>
    ) : (
        <DKGlobalInject>{props.children}</DKGlobalInject>
    );
};

export default GlobalInject;
